import React from "react";
import styles from "./index.module.css";
import { useState } from "react";
import AnalyticsTrends from "../../elements/AnalyticsTrends";
import AnalyticsCategory from "../../elements/AnalyticsCategory";
import AnalyticsBrand from "../../elements/AnalyticsBrand";
import AnalyticsPrice from "../../elements/AnalyticsPrice";
import Header from "../../elements/Header";
import { useLocation } from "react-router-dom";

const Analytics = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(location?.state?.tab || 0);
  const [tabData, setTabData] = useState([
    "Trends",
    "Price Per Category",
    "Price Per Brand",
    "Price Changes",
  ]);

  const changeActiveTab = (e) => setActiveTab(e?.target?.dataset?.idx);

  return (
    <div className={styles["container"]}>
      {/* Heading */}
      <Header />
      <hr />

      {/*  Different sections */}
      <div className={styles["tab_container"]}>
        <div className={styles["tab_content"]}>
          {tabData &&
            tabData?.map((tab, idx) => (
              <div
                className={
                  activeTab == idx
                    ? styles["tab"] + " " + styles["active"]
                    : styles["tab"]
                }
                onClick={changeActiveTab}
                data-idx={idx}
                key={idx}
              >
                {tab}
              </div>
            ))}
        </div>
      </div>
      <hr />

      {/* Analytics */}
      {tabData[activeTab] == "Trends" && <AnalyticsTrends />}
      {tabData[activeTab] == "Price Per Category" && <AnalyticsCategory />}
      {tabData[activeTab] == "Price Per Brand" && <AnalyticsBrand />}
      {tabData[activeTab] == "Price Changes" && <AnalyticsPrice />}
    </div>
  );
};

export default Analytics;
